export default __webpack_public_path__ + "static/media/faqs.9fd0f15b.svg";